import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import React, { useCallback } from 'react';
import styles from './double-select-input.module.scss';
export const DoubleSelectInput = ({ first, second, }) => {
    const handleFirstChange = useCallback((data) => {
        const selected = Array.isArray(data) ? data[0] : data;
        if (selected)
            first.onChange(selected.id);
    }, [first.onChange]);
    const handleSecondChange = useCallback((data) => {
        const selected = Array.isArray(data) ? data[0] : data;
        if (selected)
            second.onChange(selected.id);
    }, [second.onChange]);
    return (React.createElement(Horizontal, { spacing: "b", vAlignContent: "center", className: styles.row },
        React.createElement("div", { className: styles.selectWrapper },
            React.createElement(Select.Dropdown, { optionsGroups: [
                    { options: first.options },
                ], selectedOptions: first.value ? [first.value] : [], onChange: handleFirstChange, placeholder: first.placeholder, disabled: first.disabled })),
        React.createElement("div", { className: styles.selectWrapper },
            React.createElement(Select.Dropdown, { optionsGroups: [
                    { options: second.options },
                ], selectedOptions: second.value ? [second.value] : [], onChange: handleSecondChange, placeholder: second.placeholder, disabled: second.disabled }))));
};
//# sourceMappingURL=double-select-input.js.map